import { createSelector } from "@reduxjs/toolkit";

export const protestedAccountsListState = (state) => state.protestedAccountsList;

export const ProtestedAccountsListSelectors = createSelector(protestedAccountsListState, (state) => state);
